import * as yup from 'yup';

const BankAccountFormSchema = yup.object().shape({
  routing_number: yup.string().required().length(9),
  account_number: yup.string().required()
});

export default BankAccountFormSchema;
